import { useEffect, useState, useMemo } from "react";
import { useSelector } from "react-redux";
import Axios from "axios";
import AkkhorLayout from "../../layout/AkkhorLayout";
import { URL_LIST_ALL } from "../../configs/api";
import { motion, AnimatePresence } from "framer-motion";
import { checkRole } from "../../model";
import ModalNote from "./ModalNote";
import ModalImport from "./ModalImport";
import ModalChiaData from "./ModalChiaData";
import ModalDetail from "./ModalDetail";
import { confirmAlert } from "react-confirm-alert";
import moment from 'moment';
import parse from 'html-react-parser'
import { Modal } from "react-bootstrap";
import ModalAddNew from "./ModalAddNew";
import { Table } from "react-bootstrap";
import SearchBoxModal from "../../component/SearchBoxModal";
import Spinner from "../../component/Spinner";

export default function DanhSachKhachHang() {
    const { user } = useSelector((state) => state.auth);
    const { saveCustomer, setReloadCustomer } = useSelector((state) => state.save);
    const [moveDirection, setMoveDirection] = useState({});
    const [pipelines, setPipelines] = useState([]);
    const [viewType, setViewType] = useState("canban");
    const [leadStatus, setLeadStatus] = useState(1);
    const [loading, setLoading] = useState(false);
    const [reload, setReload] = useState(false);

    const allowImport = checkRole(user, 'khach-hang-cua-toi', 'import');
    const allowExport = checkRole(user, 'khach-hang-cua-toi', 'export');
    const allowAssign = checkRole(user, 'khach-hang-cua-toi', 'assign');
    const allowAdd = checkRole(user, 'khach-hang-cua-toi', 'add');
    const allowViewAll = checkRole(user, 'khach-hang-cua-toi', 'viewall');
    const allowTakeCare = checkRole(user, 'khach-hang-cua-toi', 'takecare');
    const role_viewsource = checkRole(user, 'khach-hang-cua-toi', 'viewsource');
    const viewCampaign = checkRole(user, 'campaign', '');

    const [listCustomer, setListCustomer] = useState([]);
    const [filters, setFilters] = useState({
        leadName: "",
        leadContact: "",
        campaignId: "0",
        searchPipeLine: "0",
        searchNet: "0",
        saleId: "0"
    });

    // State áp dụng khi nhấn nút Tìm kiếm
    const [appliedFilters, setAppliedFilters] = useState(filters);
    const [showFullPhones, setShowFullPhones] = useState(null);
    const [showTab, setShowTab] = useState(allowAssign ? 1 : 2);

    const [modalSearch, setModalSearch] = useState(null);
    const [listCampaign, setListCampaign] = useState([])
    const [noteCustomer, setNoteCustomer] = useState(null);

    useEffect(() => {
        if (!user?.data?.id) return;
        Axios.get(URL_LIST_ALL + `users_settings?users_id=${user.data.id}&setting_type=viewType&orderby=id-desc`, user.config)
            .then(res => {
                if (res.data.status === "success" && res.data.data?.length > 0) {
                    setViewType(res.data.data[0].setting_value || "canban"); // fallback mặc định
                }
            })
            .catch(err => console.log("Lỗi load setting:", err));
    }, [user]);

    useEffect(() => {
        Axios.get(URL_LIST_ALL + 'pipeline_settings?limit=1000', user.config).then(res => {
            const sortedPipelines = res.data.data.sort((a, b) => a.position - b.position);
            let newData = []
            sortedPipelines.forEach((item) => {
                if (checkRole(user, item.alias, 'view')) {
                    newData.push(item)
                }
            })
            setPipelines(newData);
        }).catch(err => console.log(err));
    }, []);

    const getCustomersByPipeline = (pipelinePosition) =>
        filteredCustomers.filter(c => Number(c.position) === Number(pipelinePosition));

    const fetchCustomers = async () => {
        try {
            setLoading(true)
            const config = {
                headers: {
                    Authorization: `Bearer ${user.access_token}`,
                    "Content-Type": "application/json; charset=UTF-8",
                },
            };
            const response = await Axios.get(
                `${URL_LIST_ALL}leads?limit=1000000&status=${leadStatus}&pipelinepage=customers`,
                config
            );
            if (response.data.status === "success") {
                setLoading(false)
                setListCustomer(response.data.data || []);
            } else {
                setLoading(false)
                console.warn(response.data.message);
            }
        } catch (err) {
            console.error("Lỗi lấy danh sách khách hàng:", err);
        }
    };

    useEffect(() => {
        if (user?.access_token) fetchCustomers();
    }, [user, setReloadCustomer, reload, leadStatus]);

    useEffect(() => {
        if (!saveCustomer) return;
        const userId = user?.data?.id;
        const allowedIds = saveCustomer?.accept_id || [];
        const isAllowed = Array.isArray(allowedIds) && allowedIds.includes(userId);

        if (isAllowed || allowViewAll) {
            setListCustomer((prev) => {
                const id = saveCustomer.customer_id;
                const existing = prev.find((c) => c.id === id);
                const prevStatus = existing?.position;
                const nextStatus = saveCustomer.position;

                // Xác định hướng dịch chuyển
                let dir = 0;
                if (prevStatus !== undefined && nextStatus !== undefined && prevStatus !== nextStatus) {
                    dir = nextStatus > prevStatus ? -1 : 1
                }

                setMoveDirection((prevDir) => ({
                    ...prevDir,
                    [id]: dir
                }));

                const updated = {
                    ...existing,
                    ...saveCustomer,
                    id: id,
                    net: saveCustomer.net,
                    status: saveCustomer.status_customer,
                    position: saveCustomer.position,
                    list_note:
                        saveCustomer.list_note && saveCustomer.list_note.length > 0
                            ? saveCustomer.list_note
                            : existing?.list_note || [],
                };
                const filtered = prev.filter((c) => c.id !== id);
                return [updated, ...filtered];
            });
        }
    }, [saveCustomer]);

    const getPhoneDisplay = (item) => {
        const phone = item.contact || "";
        const digits = phone.replace(/\D/g, "");
        if (showFullPhones === item.id) {
            return digits;
        }
        if (digits.length < 7) return digits;
        return `${digits.slice(0, 3)}****${digits.slice(-3)}`;
    };

    const startTakeCare = (item) => {
        if (item.position != 3 && allowTakeCare) {
            let datasave = { user_id: user.data.id, customer_id: item.customer_id, action: "note", mainnote: "Bắt đầu chăm sóc khách" }
            Axios.post(URL_LIST_ALL + 'sale_customer', datasave, user.config).then(res => {
                setShowTab(3)
                setNoteCustomer(item)
            }).catch(err => console.log(err));
        }
    }

    const khachnet = (item) => {
        if (!item.net || item.net == 0) {
            confirmAlert({
                title: "Thông báo",
                message: "Bạn muốn bỏ đánh dấu khách nét ?",
                buttons: [
                    {
                        label: "Có",
                        onClick: () => {
                            Axios.put(URL_LIST_ALL + 'leads/' + item.id, { net: (item.net && item.net == 1 ? 0 : 1) }, user.config).then(res => {
                                let datasave = { user_id: user.data.id, customer_id: item.customer_id, action: "note", mainnote: "Đánh dấu khách nét" }
                                Axios.post(URL_LIST_ALL + 'sale_customer', datasave, user.config).then(res => {
                                }).catch(err => console.log(err));
                            }).catch(err => console.log(err));
                        },
                    },
                    { label: "Không" },
                ],
            });
        }

    }
    const saveToStorage = (item) => {
        if (!item.net || item.net == 0) {
            confirmAlert({
                title: "Thông báo",
                message: "Bạn muốn chuyển khách này sang kho lưu trữ ?",
                buttons: [
                    {
                        label: "Có",
                        onClick: () => {
                            Axios.put(URL_LIST_ALL + 'leads/' + item.id, { status: (item.status && item.status == 1 ? 0 : 1) }, user.config).then(res => {
                                let datasave = { user_id: user.data.id, customer_id: item.customer_id, action: "note", mainnote: "Chuyển sang lưu trữ" }
                                setReload(!reload)
                                Axios.post(URL_LIST_ALL + 'sale_customer', datasave, user.config).then(res => {
                                }).catch(err => console.log(err));
                            }).catch(err => console.log(err));
                        },
                    },
                    { label: "Không" },
                ],
            });
        }

    }

    // Tạo danh sách khách hàng đã lọc
    const filteredCustomers = useMemo(() => {
        let result = [...listCustomer];
        const { leadName, leadContact, campaignId, saleId, searchPipeLine, searchNet } = appliedFilters;

        if (leadName) {
            result = result.filter(c =>
                c.fullname?.toLowerCase().includes(leadName.toLowerCase())
            );
        }

        if (leadContact) {
            const searchDigits = leadContact.replace(/\D/g, "");
            result = result.filter(c =>
                c.contact?.replace(/\D/g, "").includes(searchDigits)
            );
        }

        if (campaignId !== "0") {
            result = result.filter(c => c.campaign?.id == campaignId);
        }

        if (saleId !== "0") {
            result = result.filter(c =>
                c.users_follow?.some(u => String(u.user_id) === String(saleId))
            );
        }

        if (searchPipeLine !== "0") {
            result = result.filter(c => String(c.position) === String(searchPipeLine));
        }

        if (searchNet !== "0") {
            if (searchNet === "1") result = result.filter(c => c.net == 1);
            if (searchNet === "2") result = result.filter(c => !c.net || c.net == 0);
        }

        return result;
    }, [listCustomer, appliedFilters]);

    const applyFilters = () => {
        setModalSearch(false)
        setAppliedFilters(filters);
    }

    const pipelineMap = useMemo(() => {
        const map = {};
        pipelines.forEach(p => {
            map[p.position] = p;
        });
        return map;
    }, [pipelines]);

    const renderCustomerItem = (item) => {
        const direction = moveDirection[item.id] || 0;
        return <motion.div
            key={item.id}
            layout
            initial={{ opacity: 0, x: direction === 1 ? 100 : direction === -1 ? -100 : 0 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 0 }} // Không trượt khi thoát
            transition={{ duration: 0.3 }}
            className="w-100 item-customer"
        >
            <div className="card border shadow">
                <div className="card-body">
                    <div className="w-100 d-flex align-items-center justify-content-between">
                        <h4 className="fs-16 fw-medium customer-name mb-0">
                            <i className="fas fa-user-tie mr-2"></i>{item.fullname}
                        </h4>
                        <button
                            type="button"
                            className="btn btn-sm btn-warning mt-1"
                            onClick={() => setNoteCustomer(item)}
                        >
                            <i className="fas fa-plus"></i> Note
                        </button>

                    </div>

                    <div className="w-100 mobile mt-2">
                        <div className="row">
                            <div className="col">
                                <button type="button" className={"btn btn-sm " + (item.net && item.net == 1 ? "btn-warning text-white" : " text-warning btn-outline-danger")} onClick={() => khachnet(item)}>
                                    <span className="fas fa-star"></span> Nét
                                </button>
                            </div>
                            {allowImport &&
                                <div className="col">
                                    <button type="button" className={"btn btn-sm " + (item.status && item.status == 1 ? "text-warning btn-outline-danger" : "btn-warning text-white")} onClick={() => saveToStorage(item)}>
                                        <span className="fas fa-archive"></span> {item.status && item.status == 1 ? "Chuyển sang lưu trữ" : "Đang được lưu trữ"}
                                    </button>
                                </div>
                            }

                        </div>
                        <div className="row mt-1">

                            <div className="col-6">
                                <button type="button" className="btn btn-sm btn-info w-100" disabled={item.status == 1 ? false : true} onClick={() => {
                                    if (showFullPhones !== item.id) startTakeCare(item);
                                    setShowFullPhones(showFullPhones === item.id ? null : item.id);
                                }}>
                                    <span>{getPhoneDisplay(item)}</span>
                                </button>
                            </div>
                            <div className="col-3 pr-0 pl-0">
                                <button type="button" className="btn btn-sm btn-success ml-2" disabled={item.status == 1 ? false : true} onClick={() => {
                                    startTakeCare(item)
                                    window.location.href = `tel:${item.contact}`
                                }}>
                                    <i className="fas fa-phone-volume mr-1"></i> Gọi
                                </button>
                            </div>
                            <div className="col-3">
                                <ModalDetail user={user} item={item} showFullPhones={showFullPhones} setShowFullPhones={setShowFullPhones} />
                            </div>
                            {(role_viewsource && item.source) &&
                                <div className="col-6">
                                    <p className="mb-1 mt-2">
                                        Nguồn: <strong>{item.source}</strong>
                                    </p>
                                </div>
                            }
                            {item.tags && item.tags.title &&
                                <div className="col-6">
                                    <p className="mb-1 mt-2">
                                        Thẻ: <strong>{item.tags.title}</strong>
                                    </p>
                                </div>
                            }
                            {(viewCampaign && item.campaign && item.campaign.id) &&
                                <div className="col-12">
                                    Thuộc chiến dịch:  <a target='_blank' href={"/edit-campaign/" + item.campaign.id} className='mb-0'><strong>{item.campaign.title}</strong> <br /></a>
                                </div>
                            }

                        </div>
                    </div>

                    {(allowAssign && item.users_follow?.length > 0) && item.users_follow.slice(0, 1).map((u) =>
                        <div className="w-100 mt-2" key={u.id}>
                            <span>Sale:</span> <strong>{getEmailAlias(u.salemail)}</strong>
                        </div>
                    )}
                    <div className="mobile mt-2">
                        {item.list_note?.length > 0 && item.list_note.slice(0, 2).map((note) => (
                            <div key={note.id} className="border rounded p-1 pl-2 pr-2 mt-2">
                                <strong>{getEmailAlias(note.salemail)}</strong>: {parse(note.mainnote)}
                                <div className="show-time">
                                    <span className="far fa-clock"></span> {moment(note.datecreate).format("HH:mm DD/MM/YYYY")}
                                </div>
                            </div>
                        ))}
                    </div>

                </div>
            </div>
        </motion.div>
    };

    const handleChangeView = (type) => {
        setViewType(type);
        const payload = {
            users_id: user.data.id,
            setting_type: "viewType",
            setting_value: type
        };
        Axios.post(URL_LIST_ALL + "save_settings", payload, user.config)
            .catch(err => console.log("Lỗi lưu setting:", err));
    };

    useEffect(
        function () {
            if (modalSearch) {
                Axios.get(URL_LIST_ALL + "campaign?status=1", user.config)
                    .then(async (res) => {
                        if (res.data.status === "success") {
                            setListCampaign(res.data.data);
                        } else console.log(res.data.message);
                    })
                    .catch((err) => console.log(err));
            }
        }, [user, modalSearch]
    );

    const getEmailAlias = (email = "") => email.split("@")[0] || "";

    return (
        <AkkhorLayout idrole="khach-hang-cua-toi">

            <div className="w-100 d-sm-flex justify-content-between action-bar">
                <div className="d-flex justify-content-end action-bar">
                    <button type="button" className="btn btn-sm btn-outline-success" onClick={() => setModalSearch(!modalSearch)}>
                        Bộ lọc <span className="fas fa-search"></span>
                    </button>
                    {allowImport &&
                        <>{leadStatus == 1 ?
                            <button type="button" className="btn btn-sm btn-outline-warning ml-1" onClick={() => setLeadStatus(0)}>
                                Mở Kho lưu trữ <span className="fas fa-archive"></span>
                            </button>
                            :
                            <button type="button" className="btn btn-sm btn-warning ml-1" onClick={() => setLeadStatus(1)}>
                                Mở danh sách lead <span className="	fas fa-archive"></span>
                            </button>
                        }

                        </>
                    }
                    {viewType == "canban" ?
                        <button type="button" className="btn btn-sm btn-outline-danger ml-1" onClick={() => handleChangeView("list")}>
                            Danh sách <span className="fas fa-bars"></span>
                        </button>
                        :
                        <button type="button" className="btn btn-sm btn-outline-danger ml-1" onClick={() => handleChangeView("canban")}>
                            Cột <span className="fas fa-columns"></span>
                        </button>
                    }

                </div>
                {(allowAssign || allowImport || allowExport || allowAdd) && (
                    <div className="d-flex justify-content-end action-bar">
                        {allowAssign && <ModalChiaData pipelines={pipelines} user={user} />}
                        {allowImport && <ModalImport user={user} />}
                        {/* {allowExport && <button type="button" className="btn btn-sm btn-success ml-2">Export</button>} */}
                        {allowAdd && <ModalAddNew user={user} />}
                    </div>
                )}
            </div>
            {loading && <div className="w-100 d-flex justify-content-center"><Spinner /></div>}
            {viewType == "canban" &&
                <div className="list-pipeline mt-2">
                    {(pipelines && pipelines.length > 0) && pipelines.map(pipeline => {
                        const customers = getCustomersByPipeline(pipeline.position);
                        if (pipeline.inpage == 'customers') {
                            return (
                                <div className={"col-customer" + (showTab == (pipeline.position) ? " show-in-mobile" : '')} key={pipeline.id}>
                                    <div className="card border shadow">
                                        <div className="card-header text-center" style={{
                                            backgroundColor: (pipeline.header_color ? pipeline.header_color : 'transparent'),
                                            color: (pipeline.text_color ? pipeline.text_color : 'inherit')
                                        }}>
                                            {pipeline.title} <small>({customers.length})</small>
                                        </div>
                                        <div className="card-body b-wrapper p-2">
                                            <AnimatePresence mode="sync">
                                                {customers.map(item => renderCustomerItem(item))}
                                            </AnimatePresence>
                                        </div>
                                    </div>
                                </div>
                            );
                        } else {
                            return ''
                        }
                    })}
                    <div className={"w-100 d-sm-none actionbar-mobile " + (allowAssign && "has-assign")}>
                        {(pipelines && pipelines.length > 0) && pipelines.map(pipeline => {
                            if (pipeline.inpage == 'customers') {
                                return <button type="button" className={"btn btn-sm btn-success " + (showTab == (pipeline.position) ? "active" : '')}
                                    style={{
                                        backgroundColor: (pipeline.header_color ? pipeline.header_color : 'transparent'),
                                        color: (pipeline.text_color ? pipeline.text_color : 'inherit')
                                    }}
                                    onClick={() => setShowTab(pipeline.position)} key={pipeline.id}>{pipeline.title}</button>
                            } else {
                                return ''
                            }
                        })}
                    </div>
                    <div className="d-block d-sm-none w-100 p-3"></div>
                </div>
            }
            {viewType == "list" &&
                <div className="list-pipeline mt-2">
                    {filteredCustomers && filteredCustomers.length > 0 ?
                        <Table striped bordered hover className="d-none d-sm-table">
                            <thead>
                                <tr>
                                    <th>stt</th>
                                    <th>Tên</th>
                                    <th>Số điện thoại</th>
                                    <th>Gọi</th>
                                    <th>Note</th>
                                    <th>Khách nét</th>
                                    <th>Trạng thái</th>
                                    <th>Sale chăm sóc</th>
                                    <th>Lịch sử chăm sóc</th>
                                    <th>Chi tiết</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredCustomers.map((item, i) => {
                                    if (item.pipeline_inpage == 'customers') {
                                        return <tr key={item.customer_id}>
                                            <td>{i + 1}</td>
                                            <td>{item.fullname}</td>
                                            <td>
                                                <button type="button" className="btn btn-sm btn-info w-100" onClick={() => {
                                                    if (showFullPhones !== item.id) startTakeCare(item);
                                                    setShowFullPhones(showFullPhones === item.id ? null : item.id);
                                                }}>
                                                    <span>{getPhoneDisplay(item)}</span>
                                                </button>

                                            </td>
                                            <td>
                                                <button type="button" className="btn btn-sm btn-success ml-2" onClick={() => {
                                                    startTakeCare(item)
                                                    window.location.href = `tel:${item.contact}`
                                                }}>
                                                    <i className="fas fa-phone-volume mr-1"></i> Gọi
                                                </button>
                                            </td>
                                            <td>
                                                <div className="w-100">
                                                    <button
                                                        type="button"
                                                        className="w-100 btn btn-sm btn-warning mt-1"
                                                        onClick={() => setNoteCustomer(item)}
                                                    >
                                                        <i className="fas fa-plus"></i> Note
                                                    </button>
                                                </div>

                                                {allowImport &&
                                                    <div className="w-100 mt-1">
                                                        <button type="button" className={"w-100 btn btn-sm " + (item.status && item.status == 1 ? "text-warning btn-outline-danger" : "btn-warning text-white")} onClick={() => saveToStorage(item)}>
                                                            <span className="fas fa-archive"></span> {item.status && item.status == 1 ? "Chuyển sang lưu trữ" : "Đang được lưu trữ"}
                                                        </button>
                                                    </div>
                                                }

                                            </td>
                                            <td>
                                                <button type="button" className={"btn btn-sm " + (item.net && item.net == 1 ? "btn-warning text-white" : " text-warning btn-outline-danger")} onClick={() => khachnet(item)}>
                                                    <span className="fas fa-star"></span> Nét
                                                </button>
                                            </td>
                                            <td>
                                                {pipelineMap[item.position] && (
                                                    <div
                                                        className="btn btn-sm"
                                                        style={{
                                                            backgroundColor: pipelineMap[item.position].header_color || "transparent",
                                                            color: pipelineMap[item.position].text_color || "inherit"
                                                        }}
                                                    >
                                                        {pipelineMap[item.position].title}
                                                    </div>
                                                )}
                                            </td>
                                            <td>
                                                {item.users_follow?.length > 0 && item.users_follow.slice(0, 1).map((u) =>
                                                    <div className="w-100 mt-2" key={u.id}>
                                                        <span>Sale:</span> <strong>{getEmailAlias(u.salemail)}</strong>
                                                    </div>
                                                )}
                                            </td>
                                            <td>
                                                <div className="mobile mt-2">
                                                    {item.list_note?.length > 0 && item.list_note.slice(0, 2).map((note) => (
                                                        <div key={note.id} className="w-100 pb-1 mb-1">
                                                            <strong>{getEmailAlias(note.salemail)}</strong>: {parse(note.mainnote)}
                                                            <div className="show-time">
                                                                <span className="far fa-clock"></span> {moment(note.datecreate).format("HH:mm DD/MM/YYYY")}
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </td>
                                            <td>
                                                <ModalDetail button_title="Xem chi tiết" user={user} item={item} showFullPhones={showFullPhones} setShowFullPhones={setShowFullPhones} />
                                            </td>

                                        </tr>
                                    } else {
                                        return null
                                    }
                                })}
                            </tbody>
                        </Table>
                        : <h3 className="w-100 text-center">Không có dữ liệu</h3>
                    }
                </div>
            }
            {noteCustomer && (
                <ModalNote
                    pipelines={pipelines}
                    showFullPhones={showFullPhones}
                    setShowFullPhones={setShowFullPhones}
                    user={user}
                    item={noteCustomer}
                    onClose={() => setNoteCustomer(null)} // đóng modal
                />
            )}
            <Modal
                className="modal-customer-detail"
                show={modalSearch}
                onHide={() => setModalSearch(false)}
                animation={true}
                size="lg"
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        Bộ lọc khách hàng
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-sm-4 col-12 form-group">
                            <label>Tên khách hàng </label>
                            <input type="text" placeholder="Nhập tên khách hàng" className="form-control form-control-sm height32" value={filters.leadName} onChange={(e) => setFilters({ ...filters, leadName: e.target.value })} />
                        </div>
                        <div className="col-sm-4 col-12 form-group">
                            <label>Số điện thoại </label>
                            <input type="text" placeholder="Nhập số điện thoại" className="form-control form-control-sm height32" value={filters.leadContact} onChange={(e) => setFilters({ ...filters, leadContact: e.target.value })} />
                        </div>
                        <div className="col-sm-4 col-12 form-group">
                            <label>Chiến dịch </label>
                            <select className="form-select form-control form-control-sm height32" value={filters.campaignId} onChange={(e) => setFilters({ ...filters, campaignId: e.target.value })}>
                                <option value="0" >Chọn chiến dịch</option>
                                {listCampaign.map((item) => <option value={item.id} key={item.id} >{item.title}</option>)}
                            </select>
                        </div>
                        <div className="col-sm-4 col-12 form-group">
                            <label>Trạng thái </label>
                            <select className="form-select form-control form-control-sm height32" value={filters.searchPipeLine} onChange={(e) => setFilters({ ...filters, searchPipeLine: e.target.value })}>
                                <option value="0" >Chọn trạng thái</option>
                                {pipelines.map((item) => { if (item.inpage == 'customers') { return <option value={item.position} key={item.id} >{item.title}</option> } })}
                            </select>
                        </div>
                        {allowAssign &&
                            <div className="col-sm-4 col-12 form-group">
                                <label>Theo Sale đang chăm sóc </label>
                                <SearchBoxModal apiname={"users"} alldata={"?type=2"} multiple={false} placeholder="Chọn tài khoản" colvalue={'id'} colname={'title'} defaultValue={filters.saleId} name='filters.'
                                    onChange={async (e) => {
                                        setFilters({ ...filters, saleId: e })
                                    }}></SearchBoxModal>
                            </div>
                        }

                        <div className="col-sm-4 col-12 form-group">
                            <label>Theo khách nét </label>
                            <select className="form-select form-control form-control-sm height32" value={filters.searchNet} onChange={(e) => setFilters({ ...filters, searchNet: e.target.value })}>
                                <option value="0" >Tất cả</option>
                                <option value="1" >Đã đánh dấu nét</option>
                                <option value="2" >Chưa đánh dấu nét</option>
                            </select>
                        </div>
                        <div className="col-12 d-flex justify-content-center">
                            <button type="button" className="btn btn-sm btn-outline-success" onClick={() => applyFilters()}>Tìm kiếm</button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </AkkhorLayout>
    );
}
